<template>
  <div>
    <!-- Canchas -->
    <div class="is-bordered-box-shadow-main ">
      <div class="cont-row-statstype"><TypeCategoryStats /></div>
      <div class="fields">
        <div v-for="(field, index) in fieldStatisticsData" :key="index">
          <span>{{ $t(field.name) }}</span>
          <StatisticField
            :data="field.data"
            :negative="field.isNegative"
            :category-ids="field.categoryIds"
            :coordinate-point="field.coordinatePoint"
            :general-name="field.generalName"
            :single-name="field.singleName"
          />
        </div>
      </div>
    </div>
    <!-- Jugadores Destacados -->
    <div>
      <nav class="level">
        <div class="level-left">
          <div class="title-section" id="jugadores-destacados-posesion" v-observe-visibility="visibilityChanged">
            <h1>{{ $t('featured_players.title') }}</h1>
          </div>
        </div>
        <div class="lefel-right">
          <TypeCategoryStats />
        </div>
      </nav>

      <div class="columns" style="flex-wrap: wrap">
        <div
          class="column"
          v-for="featuredPlayersCategory of featuredPlayersCategories"
          :key="featuredPlayersCategory.id"
        >
          <FeaturedPlayer :data="featuredPlayersCategory" :plays="playsStack" :players="currentTeamPlayers" />
        </div>
      </div>
    </div>
    <!-- Pases y Posesion -->
    <div>
      <div id="pases-y-posesion" class="title-section" v-observe-visibility="visibilityChanged">
        <h1>{{ $t('passes_possession.title') }}</h1>
      </div>
      <div>
        <PassesPosession :passesDonutData="passesDonutData" />
      </div>
    </div>
    <!-- Categorias Posession -->
    <div>
      <nav class="level">
        <div class="level-left">
          <div id="categorias-posesion" class="title-section" v-observe-visibility="visibilityChanged">
            <h1 class="is-size-4-mobile has-text-centered-mobile">{{ $t('table.possession.title') }}</h1>
          </div>
        </div>
        <div class="lefel-right">
          <div class="cont-statstype"><TypeCategoryStats /></div>
          <BField class="is-hidden-mobile">
            <BRadioButton v-model="viewData" native-value="table"><BIcon icon="table-large"></BIcon></BRadioButton>
            <BRadioButton v-model="viewData" native-value="pie"><BIcon icon="chart-pie"></BIcon></BRadioButton>
          </BField>
        </div>
        <div class="columns is-mobile is-vcentered is-centered is-hidden-tablet">
          <div class="column is-11">
            <BField>
              <BSelect placeholder="-Tabla-" size="is-medium" v-model="viewData" expanded>
                <template v-for="(option, index) in options">
                  <option :key="`option-${index}`" :value="option.value">{{ $t(option.text) }}</option>
                </template>
              </BSelect>
            </BField>
          </div>
        </div>
      </nav>
      <div v-if="viewData === 'table'">
        <TeamDataTable
          :data="translatedTableData"
          :columns="getColumns()"
          :expandedRows="expandedRows"
          @showDetails="onShowDetails"
          @hideDetails="onHideDetails"
        />
        <DataMobileTable
          :data="translatedTableData"
          :columns="getColumns()"
          @showDetails="onShowDetails"
          @hideDetails="onHideDetails"
          @openSubcategory="onOpenSubcategory"
          @changeSubcategory="onChangeSubcategory"
        />
      </div>
      <div v-else-if="viewData === 'pie'">
        <PieChartsPosessionTeam :data="tableData" />
      </div>
    </div>
  </div>
</template>

<script>
import FeaturedPlayer from '@/components/Elements/FeaturedPlayers';
import StatisticField from '@/components/Elements/StatisticField';
import TeamDataTable from '@/components/Elements/DataTable';
import DataMobileTable from '@/components/Elements/DataMobileTable';
import PassesPosession from '@/components/Elements/PassesPosession';
import PieChartsPosessionTeam from '@/components/Elements/PieChartsPosessionTeam';
import tableConfig from '@/data/team/possessionTableData';
import TypeCategoryStats from '@/components/Elements/TypeCategoryStats';
import { mapState, mapGetters, mapMutations } from 'vuex';
import {
  analisisDeEquipoSeccionVista,
  analisisDeEquipoCategoriasDeTabla,
  analisisDeEquipoTablaGrafica,
  analisisDeEquipoDetallesCategoria,
  analisisDeEquipoDetallesSubcategoria,
} from '@/utils/analytics/teams';
import translatedTableDataMixin from '@/utils/mixins/translated-table-data';

export default {
  components: {
    FeaturedPlayer,
    StatisticField,
    TeamDataTable,
    DataMobileTable,
    TypeCategoryStats,
    PassesPosession,
    PieChartsPosessionTeam,
  },
  mixins: [translatedTableDataMixin],
  data() {
    return {
      viewData: 'table',
      // columns: tableConfig.columns,
      // expandedRows: [],
      options: [
        { text: 'general.table', value: 'table' },
        { text: 'general.graph', value: 'pie' },
      ],
    };
  },
  async created() {
    try {
      this.players = await this.$store.dispatch('playersGeneral/getPlayersBySeasonAndTeam', {
        teamId: this.$route.params.teamId,
      });
    } catch (e) {
      console.error(e);
    }
  },
  watch: {
    viewData(newValue) {
      analisisDeEquipoTablaGrafica(this.seasonId, this.teamId, this.section, newValue);
    },
    basePlaysStack: {
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.length) {
          this.setPlaysForGames(newValue);
        }
      },
    },
  },
  computed: {
    ...mapState('teamsPosession', ['featuredPlayersCategories', 'basePlaysStack']),
    ...mapState('playersGeneral', ['seasonPlayers', 'currentTeamPlayers']),
    ...mapState('loginGeneral', ['currentLanguage']),
    ...mapGetters('gamesGeneral', ['gamesPlayed']),
    ...mapGetters('teamsPosession', ['tableData', 'passesDonutData', 'fieldStatisticsData']),
    ...mapGetters('teamsPosession', { playsStack: 'getPlaysStack' }),
    ...mapGetters('teamsGeneral', ['team', 'teamId']),
    ...mapGetters({ seasonId: 'filterGeneral/getSeasonId', section: 'filterGeneral/getCategoryTypeName' }),
  },
  methods: {
    ...mapMutations('filterGeneral', ['setPlaysForGames']),
    visibilityChanged(isVisible, entry) {
      if (isVisible) {
        const sectionName = entry.target.id;
        analisisDeEquipoSeccionVista(this.seasonId, this.teamId, this.section, sectionName);
      }
    },
    getColumns() {
      return this.getTranslatedColumns(tableConfig.columns);
    },
    onShowDetails(category) {
      analisisDeEquipoCategoriasDeTabla(this.seasonId, this.teamId, category, this.section, 'mostrar');
    },
    onHideDetails(category) {
      analisisDeEquipoCategoriasDeTabla(this.seasonId, this.teamId, category, this.section, 'ocultar');
    },
    onOpenSubcategory(category) {
      analisisDeEquipoDetallesCategoria(this.seasonId, this.teamId, this.section, category);
    },
    onChangeSubcategory(subcategory) {
      analisisDeEquipoDetallesSubcategoria(this.seasonId, this.teamId, this.section, subcategory);
    },
  },
};
</script>

<style scoped lang="scss">
.cont-row-statstype {
  width: 100%;
  height: 40px;
}
.cont-statstype {
  float: left;
  margin-right: 15px;
  @media screen and (max-width: 768px) {
    display: inline-block;
    float: none;
    margin-bottom: 15px;
    margin-right: 0px;
  }
}
div.fields {
  padding-top: 30px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-radius: 20px;
}

@media screen and (max-width: 1334px) {
  div.fields {
    grid-template-columns: repeat(3, 1fr);

    & > div:last-child {
      grid-column-start: 2;
      grid-column-end: 3;
    }
  }
}

@media screen and (max-width: 962px) {
  div.fields {
    grid-template-columns: repeat(2, 1fr);

    & > div:last-child {
      grid-column-start: unset;
      grid-column-end: unset;
    }
  }
}

@media screen and (max-width: 656px) {
  div.fields {
    grid-template-columns: 1fr;
  }
}
</style>
